/**
 * Design tokens NAVICOSA RENTAL – PRD mục 4.2 → 4.5.
 * Nguồn duy nhất cho màu, chữ, khoảng cách. Không khai báo lại màu thương hiệu trong component.
 * Mã cam `#F36B21` là giá trị tạm, chờ đối chiếu brand guideline (OPEN_QUESTIONS Q-16).
 */
export const colors = {
  brand500: '#F36B21',
  brand600: '#DD5816',
  brand100: '#FFF0E6',
  brand50: '#FFF8F3',
  ink900: '#20242B',
  ink700: '#454B54',
  ink500: '#737B86',
  surface: '#FFFFFF',
  background: '#F5F6F8',
  border: '#E5E7EB',
  success: '#16834A',
  warning: '#D97706',
  danger: '#DC2626',
  info: '#2563EB',
} as const;

export const fontFamily = '"Be Vietnam Pro", "Inter", Arial, sans-serif';

export interface TypeToken {
  size: number;
  weight: number;
}

export const typography: Record<
  'display' | 'h1' | 'h2' | 'h3' | 'bodyLg' | 'body' | 'label' | 'caption' | 'micro',
  TypeToken
> = {
  display: { size: 28, weight: 700 },
  h1: { size: 24, weight: 700 },
  h2: { size: 20, weight: 700 },
  h3: { size: 18, weight: 600 },
  bodyLg: { size: 16, weight: 500 },
  body: { size: 14, weight: 400 },
  label: { size: 13, weight: 500 },
  caption: { size: 12, weight: 400 },
  micro: { size: 11, weight: 400 },
};

/** Giá thuê: 16–18px, đậm 700, màu brand-600 (PRD 4.4). */
export const priceText = { size: 17, weight: 700, color: colors.brand600 } as const;

export const spacing = [0, 4, 8, 12, 16, 20, 24, 32] as const;

export const radius = {
  control: 12,
  card: 16,
  sheet: 20,
  chip: 999,
} as const;

/** Vùng chạm tối thiểu (PRD 4.7). */
export const touchTarget = { primaryButton: 44, icon: 44 } as const;

/** Xuất CSS custom properties để dùng chung giữa Admin và Mini App. */
export function toCssVariables(): string {
  const kebab = (s: string) => s.replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
  const lines = Object.entries(colors).map(([k, v]) => `  --nv-${kebab(k)}: ${v};`);
  lines.push(`  --nv-font-family: ${fontFamily};`);
  return `:root {\n${lines.join('\n')}\n}\n`;
}
